export default {"src":"/_next/static/media/carrots.39b961ae.svg","height":39,"width":91,"blurWidth":0,"blurHeight":0};